<template>
	<div class="block" :class="'block'+currentBlock">
		<Preloader/>
		<Transitors/>

		
		<transition
				appear
				name="block-transition"
				v-on:before-enter="beforeEnter"
				v-on:enter="enter"
				v-on:before-leave="beforeLeave"
				v-on:leave="leave"
				v-on:after-leave="transitionOutReady"
				v-bind:css="false"
		>
			<div class="block-transition" v-if="blockTransitioning">
				<Intro v-if="blockType == 'intro'"/>
				<DcpBlock v-if="blockType == 'dcp'"/>
				<Cutscene v-else-if="blockType == 'cutscene'"/>
				<Minigame v-else-if="blockType == 'gameblock'"/>
				<Personalia v-if="blockType == 'personalia'"/>
			</div>
		</transition>

		<transition
			appear
			name="btn--transition"
			enter-class="btn--transition-down"
			enter-active-class="btn--transition-in"
			enter-to-class="btn--transition-final"
			leave-class="btn--transition-final"
			leave-active-class="btn--transition-out"
			leave-to-class="btn--transition-down"
	    >
			<div v-on:click="nextAction" :class="nextButtonClass" class="btn--transition" v-if="nextButtonShown">{{nextButtonLabel}}</div>
		</transition>

	</div>
</template>


<script>

	import Cutscene from './cutscene/Index.vue';
	//import Dcp from './dcp/Index.vue';
	import DcpBlock from './DcpBlock.vue';

	import Intro from './intro/Index.vue';
	import Personalia from './personalia/Index.vue';
	import Preloader from './Preloader.vue';
	import Minigame from './Minigame.vue';
	import Transitors from './Transitors.vue';
	import Velocity from 'velocity-animate'
	import { mapGetters , mapActions } from 'vuex';
	import { url } from '../const/base';

	import { lang } from '../const/base';


export default {

	components:{
		Minigame,
		Intro,
		DcpBlock,
		Cutscene,
		Transitors,
		Preloader,
		Personalia,
	},

	data(){
		return{
			show: false,
			options:{
				dropzoneSelector: 'ul',
				draggableSelector: 'li',
				excludeOlderBrowsers: true,
				multipleDropzonesItemsDraggingEnabled: true,
				onDrop: function(event) {},
				onDragstart: function(event) {},
				onDragend: function(event) {}
			}
		}
	},

	mounted(){
		this.startBlockTransition();
	},

	computed: {

		baseUrl(){
			return url;
		},

		nextButtonLabel(){

			if(lang == 'FR'){
				return 'continuer';
			}else if(lang == 'EN'){
				return 'next';
			}

			return 'verder';
		},

		...mapGetters([
			"gameLoaded",
			"blockTransitioning",
			"blockType",
			"blockSettings",
			'currentBlock',
			"lastBlock",
			"lastStage",
			"lastRound",
			"nextButtonShown",
			"stageType",
			"nextButtonAction",
			"nextButtonClass",
			"soundtrackPlaying",
			"sounds",
			"roundState"
		]),
	},

	methods:{

		...mapActions([
			"startBlockTransition",
			"stopBlockTransition",
			"toNextBlock",
			"toNextStage",
			"toNextRound",
			"hideNextButton",
			"setNextButtonAction",
			"setRoundState",
		]),

		beforeEnter (el) {

			let xPos = 0;
			let opacity = 1;

			let transition = "Fade";
			if(this.blockSettings != null && this.blockSettings.transition != null){
				transition = this.blockSettings.transition.in;
			}


			switch(transition){
				case "Left":
					xPos = -460;
					break;
				case "Right":
					xPos = 460;
					break;
				case "Fade":
					opacity = 0;
					break;
				default:
					opacity = 0;
					break;
			}

			el.style.transform = "translateX("+xPos+"px)";
			el.style.opacity = opacity;
			Velocity(el,
				{
					translateX: xPos
				},
				{
					duration:0,
				}
			);
		},
		enter (el, done) {
			Velocity(el,
				{
					translateX: 0,
					opacity: 1,
				},
				{
					duration:500,
					easing: [ 0.39, 0.67, 0.04, 0.98 ],
					complete: () =>{done();}
				}
			);
		},
		beforeLeave (el) {
			el.style.opacity = 1
		},
		leave (el, done) {
			let xPos = 0;
			let opacity = 1;
			let transition = "Fade";
			if(this.blockSettings != null && this.blockSettings.transition != null){
				transition = this.blockSettings.transition.out;
			}

			switch(transition){
				case "Left":
					xPos = -460;
					break;
				case "Right":
					xPos = 460;
					break;
				case "Fade":
					opacity = 0;
					break;
				default:
					opacity = 0;
					break;
			}

			Velocity(el,
				{
					translateX: xPos,
					opacity: opacity,
				},
				{
					duration:500,
					easing: [ 0.39, 0.67, 0.04, 0.98 ],
					complete: () =>{done();}
				}
			);
		},

		transitionOutReady(e){
			if(this.lastBlock){
			}
			else
			{
				this.toNextBlock().then(() =>
				{
					this.startBlockTransition();
				});
			}
		},

		nextAction(){
			this.nextButtonAction();
			this.setNextButtonAction(null).then(()=>{
				this.hideNextButton();
			});
		},

		next(){
			if(!this.blockTransitioning) return;
			this.hideNextButton();

			if(this.stageType == "Rounds"){
				if(this.roundState == "intro"){
					this.setRoundState("explanation");
				}
				else if(this.roundState == "explanation"){
					this.setRoundState("round");
				}
				else if(this.roundState == "round"){
					this.setRoundState("feedback");
				}
				else{
					this.toNextStage();
				}
			}
			else if(this.lastStage){
				if(this.lastRound){
					this.stopBlockTransition();
				}
				else{
					this.toNextRound();
				}
			}
			else{
				if(this.lastRound){
					this.toNextStage();
				}
				else{
					this.toNextRound();
				}
			}

		},
	}

}
</script>




// WEBPACK FOOTER //
// src/components/ContentBlock.vue